import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/data/content";
import { scrollToId } from "@/lib/scroll";
import { Eyebrow, MaskedLines, Reveal } from "./shared";

export default function Categories() {
  return (
    <section
      id="categories"
      data-testid="categories-section"
      className="bg-white py-28 md:py-36"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Eyebrow>Product Categories</Eyebrow>
            <h2 className="mt-7 font-serif font-medium leading-[1.0] tracking-tight text-navy">
              <MaskedLines
                lines={[
                  <span key="a" style={{ fontSize: "clamp(2.6rem, 5.6vw, 5.4rem)" }} className="block">
                    PRODUCT
                  </span>,
                  <span key="b" style={{ fontSize: "clamp(2.6rem, 5.6vw, 5.4rem)" }} className="block">
                    CATEGORIES<span className="text-brand">.</span>
                  </span>,
                ]}
              />
            </h2>
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.2}>
              <p className="max-w-xs text-base leading-relaxed text-fog">
                Thoughtfully presented categories across beauty, personal care,
                skincare and baby care.
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-20">
          <div className="grid border-l border-t border-softblue sm:grid-cols-2 lg:grid-cols-3">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.n}
                type="button"
                onClick={() => scrollToId("products")}
                data-testid={`category-item-${cat.n}`}
                className="group relative overflow-hidden border-b border-r border-softblue bg-white p-8 text-left transition-colors duration-500 hover:border-brand md:p-10"
                aria-label={`${cat.name} — view products`}
              >
                <span
                  aria-hidden="true"
                  className="absolute inset-0 origin-bottom scale-y-0 bg-brand transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-y-100"
                />
                <span className="relative">
                  <span className="flex items-start justify-between">
                    <span className="font-serif text-lg italic text-brand transition-all duration-500 group-hover:translate-x-1.5 group-hover:text-white/80">
                      {cat.n}
                    </span>
                    <ArrowUpRight
                      size={20}
                      strokeWidth={1.5}
                      className="text-fog/50 transition-all duration-500 group-hover:translate-x-1.5 group-hover:text-white"
                    />
                  </span>
                  <span className="mt-14 block font-serif text-[26px] font-semibold tracking-[0.1em] text-navy transition-colors duration-500 group-hover:text-white md:mt-20 md:text-3xl">
                    {cat.name}
                  </span>
                  <span className="mt-3 block max-w-[240px] text-sm leading-relaxed text-fog transition-colors duration-500 group-hover:text-white/75">
                    {cat.desc}
                  </span>
                </span>
                <span
                  aria-hidden="true"
                  className="absolute bottom-0 left-0 h-[2px] w-full origin-left scale-x-0 bg-brand-bright transition-transform delay-100 duration-500 group-hover:scale-x-100"
                />
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-8">
          <p className="text-[11px] uppercase tracking-[0.28em] text-fog/70">
            Nine categories · One philosophy of care
          </p>
        </Reveal>
      </div>
    </section>
  );
}
